import classNames from 'classnames';
import React from 'react';

interface ICheckbox {
    className?: string;
    checked: boolean;
    label?: string;
    onChange: (value: boolean) => void;
}

const Checkbox = (p: ICheckbox) => {
    const cls = classNames('form-check', p.className);
    const id = React.useId();
    return (
        <div className={cls}>
            <input
                id={id}
                type="checkbox"
                className="form-check-input"
                checked={p.checked}
                onChange={e => p.onChange(e.target.checked)}
            />
            {p.label && (
                <label className="form-check-label" htmlFor={id}>
                    {p.label}
                </label>
            )}
        </div>
    );
};

export default Checkbox;
